"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import _ from "underscore";
import Api from "../../api/api";
import get from "../data/get";
import CustomerLoadSelector from "../indexer/customer_load_selector";
import ShipmentSelector from "../indexer/shipment_selector";
import PodDeliverySelector from "../indexer/pod_delivery_selector";
import IndexingShipmentSelector from "./indexing_shipment_selector";
const getDocumentAssignmentComponent = (flowStep, load, document, settings, toggleDeliveryDocument, toggleCustomerLoadDocument, toggleShipmentDocument, allDocumentIds, shipmentDocumentSelections, deliveryDocumentSelections, shipments, onLoadUrl) => {
  if (!load) {
    return;
  }
  if (shouldShowIndexShipmentSelector(load, document, settings, flowStep)) {
    return getIndexingShipmentSelector(
      shipmentDocumentSelections,
      toggleShipmentDocument,
      document
    );
  }
  let podSelector = null;
  let customerLoadSelector = null;
  let shipmentSelector = null;
  if (shouldShowDeliverySelector(settings, onLoadUrl)) {
    podSelector = getPodOnlyShipmentSelector(
      load,
      document,
      toggleDeliveryDocument,
      deliveryDocumentSelections
    );
  }
  if (flowStep === "audit") {
    if (Api.Account.shouldAssignDocumentsToCustomerLoads(settings)) {
      customerLoadSelector = getCustomerLoadSelector(
        load,
        document,
        toggleCustomerLoadDocument,
        allDocumentIds
      );
    }
    if (shouldShowShipmentSelector(load, document, settings)) {
      shipmentSelector = getShipmentSelector(
        load,
        document,
        toggleShipmentDocument,
        allDocumentIds,
        shipments
      );
    }
  }
  return /* @__PURE__ */ React.createElement("div", null, podSelector, customerLoadSelector, shipmentSelector);
};
const getIndexingShipmentSelector = (shipmentDocumentSelections, toggleShipmentDocument, selectedDocument) => {
  return /* @__PURE__ */ React.createElement(
    IndexingShipmentSelector,
    {
      shipmentDocumentSelections,
      toggleShipmentDocument,
      selectedDocument
    }
  );
};
const getCustomerLoadSelector = (load, document, toggleDocument, allDocumentIds) => {
  const tmsLoad = load.load;
  const tmsCustomerLoads = get.tmsCustomerLoads(tmsLoad);
  if (tmsCustomerLoads.length < 2) {
    return null;
  }
  if (!isCustomerFacingDocument(document)) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    CustomerLoadSelector,
    {
      tmsCustomerLoads,
      toggleCustomerLoadDocument: toggleDocument,
      document,
      allDocumentIds
    }
  );
};
const getShipmentSelector = (load, document, toggleDocument, allDocumentIds, shipments) => {
  const tmsLoad = load.load;
  const drops = get.tmsDrops(tmsLoad);
  const tmsShipments = Object.values(shipments);
  if (!tmsShipments.length) return null;
  const sortedTmsShipments = _.sortBy(tmsShipments, (shipment) => {
    return shipment.shipment_id;
  });
  const shipmentsWithDrops = sortedTmsShipments.map((shipment) => {
    const shipmentDrops = drops.filter(
      (drop) => drop.tms_shipment_ids.includes(shipment.id)
    );
    return __spreadProps(__spreadValues({}, shipment), { drops: shipmentDrops });
  });
  return /* @__PURE__ */ React.createElement(
    ShipmentSelector,
    {
      allDocumentIds,
      tmsShipments: shipmentsWithDrops,
      document,
      toggleShipmentDocument: toggleDocument
    }
  );
};
const shouldShowShipmentSelector = (load, document, settings) => {
  const shouldAssignDocumentsToShipments = Api.Account.shouldAssignDocumentsToShipments(settings);
  const multiShipments = hasMultipleShipments(load);
  const customerFacingDocument = isCustomerFacingDocument(document);
  return shouldAssignDocumentsToShipments && multiShipments && customerFacingDocument;
};
export const shouldShowIndexShipmentSelector = (load, document, settings, flowStep) => {
  const indexAuditSplitEnabled = settings.index_audit_split_enabled;
  const indexPodShipmentsAssignmentEnabled = settings.index_shipment_assignment_enabled;
  const inIndexStep = flowStep == "index";
  const showShipmentSelector = shouldShowShipmentSelector(
    load,
    document,
    settings
  );
  return indexAuditSplitEnabled && indexPodShipmentsAssignmentEnabled && showShipmentSelector && inIndexStep;
};
const shouldShowDeliverySelector = (settings, onLoadUrl) => {
  return (settings.index_delivery_assignment_enabled || onLoadUrl) && hasDeliveryDocumentAssignmentStrategy(settings);
};
const hasDeliveryDocumentAssignmentStrategy = (settings) => {
  return settings.document_assignment_strategy === "delivery" || settings.document_assignment_strategy === "customer_load_and_delivery";
};
const getPodOnlyShipmentSelector = (load, document, toggleDocument, deliveryDocumentSelections) => {
  if (!hasMultipleDeliveries(load)) {
    return null;
  }
  if (!document.is_pod) {
    return;
  }
  const tmsLoad = load.load;
  return /* @__PURE__ */ React.createElement(
    PodDeliverySelector,
    {
      tmsDeliveries: get.tmsDropDeliveries(tmsLoad),
      document,
      carrierInvoice: getCarrierInvoice(load, document),
      toggleDeliveryDocument: toggleDocument,
      deliveryDocumentSelections
    }
  );
};
const hasMultipleDeliveries = (load) => {
  return get.tmsDropDeliveries(load.load).length > 1;
};
const hasMultipleShipments = (load) => {
  var _a, _b;
  return ((_b = (_a = load == null ? void 0 : load.load) == null ? void 0 : _a.tms_shipment_ids) == null ? void 0 : _b.length) > 1;
};
const isCustomerFacingDocument = (document) => {
  const customerVisibleDocumentTypes = Api.Account.customerVisibleDocumentTypes();
  return _.contains(customerVisibleDocumentTypes, document.type);
};
export const getCarrierInvoice = (load, document) => {
  return load.carrier_invoices.find(
    (ci) => ci.id == document.carrier_invoice_id
  );
};
export default getDocumentAssignmentComponent;
